module.exports = __webpack_public_path__ + "static/media/thumb.644b62bf.png";